import { render, staticRenderFns } from "./SendSmsTab.vue?vue&type=template&id=fedbead0"
import script from "./SendSmsTab.vue?vue&type=script&lang=js"
export * from "./SendSmsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports